import React, { Component } from 'react'
import { Select } from 'semantic-ui-react'

class SelectSearch extends Component {
  static propTypes = {
    ...Select.propTypes
  }

  render () {
    return (
      <Select search {...this.props} />
    )
  }
}

SelectSearch.propTypes = {}

export default SelectSearch
